import {useFormik} from "formik";
import * as yup from "yup";
import axios from "axios";
import {API} from "../../../helpers/constants";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {USERS} from "../locales/namespaces";
import useUserData from "../../../hooks/user/useUserData";
import {getRouteUrl} from "../../../helpers/getRouteUrl";
import {ROUTE_PAGE_USERS_DETAILS} from "../routes/routes";
import {useHistory} from "react-router-dom";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../../helpers/errorHandling";
import {enqueueSnackbar} from "notistack";
import useUserAction from "../../../hooks/user/useUserAction";

const useUserForm = ({
                         id,
                         user,
                         countries,
                         currencies,
                         languages,
                         nationalities
                     }) => {
    const {token, isLoggedIn} = useUserData()
    const {userLogout} = useUserAction()
    const history = useHistory()
    const {t} = useTranslation(USERS)
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const validationSchema = yup.object({

        password: !id ? yup.string()
            .required(t('Required'))
            .matches(/^.{60}$|(^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z\d])|(?=.*?[A-Z])(?=.*?\d)(?=.*?[^a-zA-Z\d])|(?=.*?[a-z])(?=.*?\d)(?=.*?[^a-zA-Z\d])).{7,16}$)/,
                t('Password must be between 7-16 latin characters and contain at least 3 of the following. -Upper case character -Lower case character -Numeric digit -Special character')) : yup.string().notRequired().matches(/^.{60}$|(^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z\d])|(?=.*?[A-Z])(?=.*?\d)(?=.*?[^a-zA-Z\d])|(?=.*?[a-z])(?=.*?\d)(?=.*?[^a-zA-Z\d])).{7,16}$)/,
            t('Password must be between 7-16 latin characters and contain at least 3 of the following. -Upper case character -Lower case character -Numeric digit -Special character')),
        confirmPassword: !id ? yup.string()
            .required(t('Required'))
            .oneOf([yup.ref('password'), null], t('Passwords must match')) : yup.string().test('passwords-match', t('Passwords must match'), function (value) {
            return this.parent.password === value
        }),
        LoginName: yup
            .string()
            .required(t(t('Required'))),
        email: yup
            .string()
            .required(t('Required'))
            .email(t('Enter a valid email')),
    })

    const onSubmit = (values) => {
        setIsLoading(true)
        axios({
            method: 'post',
            data: {
                UserId: id,
                LoginName: values.LoginName,
                password: values.password,
                isActive: values.isActive,
                email: values.email,
                isAdmin: values.isAdmin
            },
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: !id ? `${API}/user/store` : `${API}/user/update`
        }).then(response => {
            enqueueSnackbar(!id ? t('User created successfully!') : t('User updated successfully!'), {
                    variant: 'success',
                    autoHideDuration: 800,
                    onClose: () => history.push(getRouteUrl(ROUTE_PAGE_USERS_DETAILS, {id: response.data.userid}))
                }
            )
            setIsLoading(false)
        }).catch(error => {
            enqueueSnackbar(handleAxiosErrors(error, error?.data?.message, {
                    variant: 'error',
                }
            ))
            setIsLoading(false)
            logoutUnauthorizedUser(error, isLoggedIn, userLogout)
        })
    }

    const formik = useFormik({
        initialValues: {
            isActive: id ? user.isActive : true,
            LoginName: user?.LoginName || '',
            password: user?.password || '',
            confirmPassword: user?.password || '',
            email: user?.email || '',
            isAdmin: user.isAdmin || false
        },
        validationSchema: validationSchema,
        onSubmit: onSubmit,
    })

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return {
        formik,
        showPassword,
        handleClickShowPassword,
        handleMouseDownPassword,
        isLoading
    }
}

export default useUserForm

